import React from "react";

interface DraftBulkActionsProps {
  selectedCount: number;
  onDelete: () => void;
}

export default function DraftBulkActions({
  selectedCount,
  onDelete,
}: DraftBulkActionsProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 transform">
      <div className="flex items-center gap-4 rounded-lg bg-white px-6 py-3 shadow-lg border border-gray-200">
        <span className="text-sm font-medium text-gray-700">
          {selectedCount}개 선택됨
        </span>
        
        <div className="h-4 w-px bg-gray-300" />
        
        <div className="flex gap-2">
          <button
            onClick={onDelete}
            className="rounded bg-red-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-600"
          >
            삭제
          </button>
        </div>
      </div>
    </div>
  );
}